var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.744 2C15.2415 2 17.1248 4.03775 17.1248 6.74V11.891C17.1248 13.274 16.6358 14.5235 15.747 15.41C14.9498 16.2042 13.9155 16.625 12.756 16.625H5.36626C4.20901 16.625 3.17551 16.205 2.37751 15.41C1.48876 14.5235 0.999756 13.274 0.999756 11.891V6.74C0.999756 4.03775 2.88301 2 5.38051 2H12.744ZM12.744 3.125H5.38051C3.49426 3.125 2.12476 4.64525 2.12476 6.74V11.891C2.12476 12.9732 2.49676 13.94 3.17176 14.6127C3.75376 15.194 4.51351 15.5 5.36851 15.5H12.744C12.7455 15.4985 12.7515 15.5 12.756 15.5C13.6118 15.5 14.3708 15.194 14.9528 14.6127C15.6285 13.94 15.9998 12.9732 15.9998 11.891V6.74C15.9998 4.64525 14.6303 3.125 12.744 3.125ZM13.926 6.5966C14.1218 6.83735 14.085 7.19135 13.8443 7.38785L10.5113 10.0969C10.0898 10.4313 9.58576 10.5986 9.08251 10.5986C8.58076 10.5986 8.08051 10.4328 7.66201 10.1013L4.29826 7.38935C4.05601 7.19435 4.01851 6.8396 4.21276 6.5981C4.40851 6.35735 4.76251 6.3191 5.00401 6.51335L8.36476 9.22235C8.78701 9.55685 9.38176 9.55685 9.80701 9.21935L13.134 6.51485C13.3755 6.3176 13.7295 6.3551 13.926 6.5966Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3b736c792c19dcf90e321b8a953fce76.svg";
export { ForwardRef as ReactComponent };